<template>
	<fieldset>
		<legend>{{ legend }}</legend>
		<FieldWrap
			v-for="(field, name) in filteredFields"
			:fieldName="name"
			:fieldData="field"
			:key="name"
		/>
	</fieldset>
</template>

<script>
import FieldWrap from "./FieldWrap.vue";
export default {
	components: {
		FieldWrap
	},

	computed: {
		filteredFields() {
			let nonNullKeys = Object.keys(this.fields).filter(
				k => this.fields[k] !== null
			);

			return nonNullKeys.reduce((a, k) => {
				a[k] = this.fields[k];
				return a;
			}, {});
		}
	},

	props: {
		fields: {
			type: Object,
			required: true
		},

		legend: {
			type: String,
			required: true
		}
	}
};
</script>
